import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import moment from 'moment';
import { ReactComponent as UploadIcon } from '../../../assets/svg/upload-cloud.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/svg/trash3.svg';
import { gql } from '@apollo/client';
import _ from 'lodash';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import service from '../../../services/graphQlServices';
import LoadingBar from '../../components/global/loadingBar';
import { withRouter } from '../../../services/withRoute';
import Dropzone from 'react-dropzone';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
var randomize = require('randomatic');
const prettyBytes = require('pretty-bytes');

const uploadVendorFile = gql`
	mutation UploadVendorFile($branchId: String!, $uploadInput: FileUploadInput!) {
		uploadVendorFile(branchId: $branchId, uploadInput: $uploadInput) {
			signedUrl
			fileId
		}
	}
`;

const getBranchFileUploadStatus = gql`
	query RootQuery($branchId: String!, $uploadBatchId: String) {
		branchFileUploadStatus(branchId: $branchId, uploadBatchId: $uploadBatchId) {
			uploadedCount
			filesUploaded {
				_id
				fileType
				originalFileName
				s3KeyOriginal
				originalFileSizeInMb
			}
		}
	}
`;

class UploadFilesForRemap extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			imageSrc: null,
			files: [],
			isUploadComplete: false,
			showFileModal: false,
			showFileFile: {},
			showFileSrc: null,
			fileUpload: [],
			uploadFileErrorCount: 0,
			totalSignedUrlErrorCount: 0,
			files: [],
			readyToUploadFiles: [],
			isFileLoading: false,
			isReadyFilesLoaded: false,
			isUploadComplete: false,
			showFileModal: false,
			uploadBatchId: randomize('Aa0', 11),
		};
	}
	timer = null;

	componentWillUnmount() {
		if (this.timer) {
			clearInterval(this.timer);
		}
	}

	componentDidUpdate = (prevProps) => {
		if (
			this.props.triggerFileUpload !== prevProps.triggerFileUpload &&
			this.props.triggerFileUpload === true
		) {
			this.startUploadingFiles();
		}
	};

	checkUploadStatus = () => {
		let fileVariables = {
			branchId: this.props.branchId,
			uploadBatchId: this.state.uploadBatchId,
		};
		let failCounter = 0;
		let complete = false;
		let completedFiles = [];
		let processing = false;
		this.timer = setInterval(async () => {
			if (processing === false) {
				processing = true;

				let file = await this.getFileInfo(
					getBranchFileUploadStatus,
					fileVariables,
					'branch',
				);
				if (file !== false) {
					failCounter = 0;
					if (file.uploadedCount > 0 && complete === false) {
						let uploadedCount = file.uploadedCount;

						let tempUploadedFile = file.filesUploaded;
						await this.processUploadedFiles(file, completedFiles);
						for (let file of tempUploadedFile) {
							let found = undefined;
							found = _.find(completedFiles, { _id: file._id });

							if (found) {
								continue;
							}
							completedFiles.push(file);
						}

						if (
							_.size(completedFiles) + this.state.totalSignedUrlErrorCount ===
							_.size(this.state.fileUpload)
						) {
							complete = true;
						}
					}
					processing = false;
				} else {
					failCounter += 1;
					if (failCounter > 9) {
						this.uploadFailedCompute();
						clearInterval(this.timer);
					}
					processing = false;
				}
			}
		}, 1000);
	};

	processUploadedFiles = async (file, completedFiles) => {
		let inx = 0;
		let tempFileUploaded = file.filesUploaded;

		for (let file of tempFileUploaded) {
			let found = undefined;
			found = _.find(completedFiles, { _id: file._id });

			if (found) {
				continue;
			}

			let files = this.state.files;
			let fileUpload = this.state.fileUpload;
			delete file['__typename'];

			let foundIndex = -1;
			foundIndex = _.findIndex(fileUpload, {
				id: file._id,
			});
			if (foundIndex !== -1) {
				fileUpload[foundIndex].isUploading = false;
				fileUpload[foundIndex].isSuccess = true;
				file.fileType = fileUpload[foundIndex].type2;
				file.src = fileUpload[foundIndex].src;
			}

			files.push(file);

			this.setState({ files, fileUpload }, () => {
				if (
					_.size(files) + this.state.totalSignedUrlErrorCount ===
					_.size(this.state.fileUpload)
				) {
					this.setState({
						isUploadComplete: true,
						isFileLoading: false,
						fileUpload: [],
						readyToUploadFiles: [],
						isReadyFilesLoaded: false,
					});

					this.props.uploadFileCompleted(files);
					clearInterval(this.timer);
				}
			});

			inx++;
		}
	};

	uploadFailedCompute = () => {
		let fileUpload = this.state.fileUpload;

		fileUpload = _.map(fileUpload, (item, index) => {
			item.isUploading = false;
			if (item.isSuccess === true) {
				return item;
			} else {
				item.isSuccess = false;
			}
			return item;
		});

		this.setState({
			isFileLoading: false,
			fileUpload,
			isUploadComplete: true,
			readyToUploadFiles: [],
			isReadyFilesLoaded: false,
		});
	};

	uploadFile = async (mutation, variables, files, index) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		let fileUpload = this.state.fileUpload;
		try {
			response = await service.mutation(mutation, variables, vendorID, usertoken, 'vendors');
		} catch (e) {
			fileUpload[index].isSignedUrlError = true;
		}

		if (response[0] === true) {
			fileUpload[index].signedUrl = response[1].data.uploadVendorFile['signedUrl'];
			fileUpload[index].id = response[1].data.uploadVendorFile['fileId'];
		} else {
			fileUpload[index].isSignedUrlError = true;
		}
		this.setState({ fileUpload }, async () => {
			let isComplete = _.every(fileUpload, (fi, inx) => {
				if (fi.signedUrl !== null || fi.isSignedUrlError == true) {
					return true;
				} else {
					return false;
				}
			});

			if (isComplete) {
				let totalSignedUrlErrorCount = _.size(
					_.filter(fileUpload, { isSignedUrlError: true }),
				);
				this.setState({ totalSignedUrlErrorCount, uploadFileErrorCount: 0 }, () => {
					let isFirst = true;
					_.forEach(files, async (f, inx) => {
						if (fileUpload[inx].isSignedUrlError === true) {
							return;
						}
						if (isFirst === true) {
							isFirst = false;
							this.checkUploadStatus();
						}
						let res = false;
						res = await this.axiosPutFileCallToS3Bucket(f, fileUpload[inx].signedUrl);
						if (res === true) {
						} else {
							this.setState({
								uploadFileErrorCount: this.state.uploadFileErrorCount + 1,
							});
						}
					});
				});
			}
		});
	};

	readUploadingFile = (file, index, size) => {
		let reader = new FileReader();

		reader.onload = (e) => {
			let fileUpload = this.state.fileUpload;
			fileUpload[index].src = reader.result;
			this.setState({ fileUpload });
			if (index + 1 === size) {
				this.props.updateFileCount(_.size(fileUpload));
				this.setState({
					//isFileLoading: true,
					isReadyFilesLoaded: true,
					isUploadComplete: false,
				});
			}
		};
		reader.readAsDataURL(file);
	};

	onDrop = async (files) => {
		let fileUpload = this.state.fileUpload;
		let initialFileUploadSize = _.size(this.state.fileUpload);
		let uploadBatchId = this.state.uploadBatchId;
		let readyToUploadFiles = this.state.readyToUploadFiles;
		_.forEach(files, async (f, inx) => {
			inx += initialFileUploadSize;
			readyToUploadFiles.push(f);
			fileUpload.push({
				signedUrl: null,
				id: null,
				type: '',
				type2: '',
				src: null,
				isSuccess: false,
				isUploading: true,
				isSignedUrlError: false,
				originalFileName: f.name,
				originalFileSizeInMb: f.size,
				originalDateTime: moment(f['originalDate']).unix(),
				uploadBatchId: this.state.uploadBatchId,
			});
			if (f.type === 'application/pdf') {
				fileUpload[inx].type = 'pdf';
				fileUpload[inx].type2 = 'pdf';
			} else if (f.type === 'image/jpeg' || f.type === 'image/png') {
				fileUpload[inx].type = 'image';
				if (f.type === 'image/jpeg') {
					fileUpload[inx].type2 = 'jpeg';
				} else if (f.type === 'image/png') {
					fileUpload[inx].type2 = 'png';
				}
			}
		});

		this.setState({ fileUpload, uploadBatchId, uploadFileErrorCount: 0 }, () => {
			_.forEach(files, async (f, inx) => {
				this.readUploadingFile(
					f,
					_.size(fileUpload) - _.size(files) + inx,
					_.size(fileUpload),
				);
			});
		});
	};

	startUploadingFiles = () => {
		this.setState({ isFileLoading: true });
		_.forEach(this.state.fileUpload, async (f, inx) => {
			let uploadVariables = {
				branchId: this.props.branchId,
				uploadInput: {
					originalFileName: f.originalFileName,
					originalDateTime: f.originalDateTime,
					uploadBatchId: f.uploadBatchId,
				},
			};

			let res = await this.uploadFile(
				uploadVendorFile,
				uploadVariables,
				this.state.readyToUploadFiles,
				inx,
			);
		});
	};

	handleDeleteUploadReadyFile = async (index) => {
		let readyToUploadFiles = this.state.readyToUploadFiles;
		let fileUpload = this.state.fileUpload;
		fileUpload.splice(index, 1);
		readyToUploadFiles.splice(index, 1);
		this.setState({ readyToUploadFiles, fileUpload }, () => {
			this.props.updateFileCount(_.size(fileUpload));
		});
	};

	render() {
		return (
			<div className="remap-upload-outer">
				<div className="upload-header">{this.props.uploadTitle}</div>
				<div className="uploaded-files-container">
					<>
						{_.map(this.state.files, (file, index) => {
							return (
								<div
									key={`sjdflksjdf2367567${index}`}
									className="uploaded-files-image-bg"
									style={
										file.fileType === 'jpeg' || file.fileType === 'png'
											? {
													backgroundImage: `url(${file.src})`,
											  }
											: {}
									}
								>
									{file.fileType === 'pdf' ? (
										<Document
											file={file.src}
											error=""
											loading={
												<div className="loading-indicator-fg">
													Loading...
												</div>
											}
										>
											<Page pageNumber={1} width={120} />
										</Document>
									) : null}
									<div
										className="uploaded-files-image-fg"
										onClick={() => {
											this.setState({
												showFileFile: file,
												showFileSrc: file.src,
												showFileModal: true,
											});
										}}
									>
										<div className="uploaded-files-text">
											{file.originalFileName}
										</div>
										<div className="uploaded-lower-details">
											<span className="size-indicator">
												{prettyBytes(file.originalFileSizeInMb)}
											</span>
										</div>
									</div>
								</div>
							);
						})}
					</>

					{this.state.isReadyFilesLoaded && !this.state.isFileLoading ? (
						<>
							{_.map(this.state.fileUpload, (file, index) => {
								if (file.isSuccess === true) {
									return null;
								}
								return (
									<div
										className="uploaded-files-image-bg"
										key={`spodfj3489usiodjejfhois1s${index}`}
										style={
											file.type === 'pdf'
												? {}
												: {
														backgroundImage: `url(${file.src})`,
												  }
										}
									>
										{file.type === 'pdf' ? (
											<Document
												file={file.src}
												error=""
												loading={
													<div className="loading-indicator-fg">
														Loading...
													</div>
												}
											>
												<Page pageNumber={1} width={120} />
											</Document>
										) : null}
										<div
											className="uploaded-files-image-fg"
											onClick={() => {
												this.setState({
													showFileFile: file,
													showFileSrc: file.src,
													showFileModal: true,
												});
											}}
										>
											<div className="uploaded-files-text">
												{file.originalFileName}
											</div>
											<div className="uploaded-lower-details">
												<span className="size-indicator">
													{prettyBytes(file.originalFileSizeInMb)}
												</span>
												<span
													className="delete-icn"
													onClick={(e) => {
														e.stopPropagation();
														this.handleDeleteUploadReadyFile(index);
													}}
												>
													<DeleteIcon />
												</span>
											</div>
										</div>
									</div>
								);
							})}
						</>
					) : null}
					{this.state.isFileLoading ? (
						<>
							{_.map(this.state.fileUpload, (file, index) => {
								if (file.isSuccess === true) {
									return null;
								}
								return (
									<div
										className="uploaded-files-image-bg"
										style={
											file.type === 'pdf'
												? {}
												: {
														backgroundImage: `url(${file.src})`,
												  }
										}
									>
										{file.type === 'pdf' ? (
											<Document
												file={file.src}
												error=""
												loading={
													<div className="loading-indicator-fg">
														Loading...
													</div>
												}
											>
												<Page pageNumber={1} width={120} />
											</Document>
										) : (
											<div className="loading-indicator-fg">Loading...</div>
										)}
									</div>
								);
							})}
						</>
					) : null}
					{this.state.uploadFileErrorCount + this.state.totalSignedUrlErrorCount > 0 ? (
						<div className="upload-error-text">
							{this.state.uploadFileErrorCount + this.state.totalSignedUrlErrorCount}{' '}
							attachment failed to upload, try again
						</div>
					) : null}
				</div>
				<Dropzone
					onDrop={this.onDrop}
					accept={'image/jpeg, image/png'}
					multiple={true}
					disabled={
						this.state.isFileLoading ||
						this.props.branchId === null ||
						this.props.branchId === undefined ||
						this.props.isLoading
					}
				>
					{({ getRootProps, getInputProps }) => (
						<div className="remap-upload-container" {...getRootProps({})}>
							<input {...getInputProps()} />
							<span className="cloud-icn">
								<UploadIcon />
							</span>
							<span className="middle-text">Drag your images here</span>
							<span className="bottom-text">or Browse from your computer </span>
						</div>
					)}
				</Dropzone>
			</div>
		);
	}
}

export default withRouter(UploadFilesForRemap);
